// randomHud.js
var RandomHud = pc.createScript('randomHud');
var ind;

RandomHud.attributes.add('objAmnt', {type: 'number', description: 'ammount of hidden objects'});

// initialize code called once per entity
RandomHud.prototype.initialize = function() {
    this.ind = Math.floor(Math.random() * this.objAmnt);
    for(var i = 0; i <= this.objAmnt - 1; i++){
        var tobj = this.entity.children[i];
        tobj.enabled = false;
    }
    this.entity.children[this.ind].enabled = true;
};

// update code called every frame
RandomHud.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// RandomHud.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

